import React, {Component} from 'react'
import QrReader from 'react-qr-reader'
import {connect} from 'react-redux';
import {
    getAdminEmpresa,
    getFiscalEmbarque,
    getGestorEmpresa,
    getMotoristaEmpresa,
    getGestorOperacoes,
    getOperadorEmpresa,
    PERFIL_ADMIN
} from '../../security/securityContext';
import Titulo from '../comum/Titulo';
import Autorizacao from '../../security/Autorizacao';
import {showErrorMsg, showSuccessMsg} from '../../util/messagesUtil';
import buscarReserva from '../../actions/reserva/buscarReserva';
import moment from 'moment';
import pt from 'date-fns/locale/pt';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import {formatarReal} from '../../util/numberUtil';
import embarcarPassageiro from '../../actions/reserva/embarcarPassageiro';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import qs from 'qs';
import selecionarItinerario from '../../actions/itinerario/selecionarItinerario';

registerLocale('pt', pt);
setDefaultLocale('pt');

class PainelEmbarqueComQrCode extends Component {
    state = {
        reserva: null,
    };

    // componentDidMount() {
    //     this.props.buscarReserva(295712, this.props.empresaSelecionada.id)
    //         .then((resp) => {
    //             const reserva = resp.payload.data;
    //             if (!reserva) {
    //                 showErrorMsg('Reserva não encontrada.');
    //                 return
    //             }
    //             if (reserva.situacaoReserva !== 'APROVADO') {
    //                 showErrorMsg('Reserva não está na situação aprovada.');
    //                 return
    //             }
    //             this.setState({reserva: reserva})
    //         })
    // }

    componentDidMount() {
        this.props.selecionarItinerario(null);
        const parametros = qs.parse(this.props.history.location.search, {ignoreQueryPrefix: true});
        if (parametros.itinerario) {
            this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario)
        }
    }

    handleScan = data => {
        if (data) {
            const reservaId = data.substr(44, 9);
            this.setState({buscando: true});
            this.props.buscarReserva(Number(reservaId), this.props.empresaSelecionada.id)
                .then((resp) => {
                    const reserva = resp.payload.data;
                    if (!reserva) {
                        showErrorMsg('Reserva não encontrada.');
                        return
                    }
                    if (this.props.itinerarioSelecionado.id && reserva.itinerarioId !== this.props.itinerarioSelecionado.id) {
                        showErrorMsg('Reserva não pertence ao itinerário selecionado');
                        return
                    }
                    if (reserva.situacaoReserva !== 'APROVADO') {
                        showErrorMsg('Reserva não está na situação aprovada.');
                        return
                    }
                    this.setState({reserva: reserva})
                })
        }
    };
    handleError = err => {
        console.error(err)
    };

    exibirScanner() {
        return <div className="d-flex justify-content-center">
            <QrReader
                delay={1000}
                onError={this.handleError}
                onScan={this.handleScan}
                style={{width: '50%'}}
            /></div>
    }

    embarcarPassageiro() {
        this.props.embarcarPassageiro(this.props.empresaSelecionada.id, this.state.reserva.id).then(() => {
            showSuccessMsg('Embarque de passageiro realizado com sucesso!');
            this.props.buscarReserva(this.state.reserva.id, this.props.empresaSelecionada.id).then((resp) => {
                this.setState({reserva: resp.payload.data})
            })
        })
    }

    exibirDadosReserva() {
        const reserva = this.state.reserva;
        return <React.Fragment>
            <div className="card-group mt-2">
                <div className="card col-sm-12 row align-content-center item-passagem" style={{margin: 0}}>
                    <div className="card-body img-reserva card-reserva col-sm-4"/>
                    <div className="card-body ml-2 align-content-center card-reserva col-sm-8">
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Data da compra:</label>
                                <p>{moment(reserva.dataVenda, 'DD/MM/YYYY').format('DD/MM/YYYY')}</p>
                            </div>
                            <div className="col-sm-6">
                                <label>Data/hora partida:</label>
                                <p>{reserva.dataHoraPartida}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Número do pedido:</label>
                                <p>{reserva.pedidoId}</p>
                            </div>
                            <div className="col-sm-6">
                                <label>Número da reserva:</label>
                                <p>{reserva.id}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <label>Passageiro:</label>
                                <p>{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Origem:</label>
                                <p>{reserva.descCidadeOrigem}</p>
                            </div>
                            <div className="col-sm-6">
                                <label>Destino:</label>
                                <p>{reserva.descCidadeDestino}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12">
                                <label>Vendedor:</label>
                                <p>{capitalizarTodasPrimeirasLetras(reserva.nomeVendedor)}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Valor:</label>
                                <p>{formatarReal(reserva.valorTotalReserva)}</p>
                            </div>
                            <div className="col-sm-6">
                                <label>Situação:</label>
                                <p>{capitalizarTodasPrimeirasLetras(reserva.situacaoReserva)}</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <label>Data/Hora embaque:</label>
                                <p>{reserva.dataHoraEmbarque ?
                                    <span style={{color: 'green'}}>{reserva.dataHoraEmbarque}</span> :
                                    <span style={{color: 'red'}}>Passageiro não embarcado</span>}</p>
                            </div>
                            <div className="col-sm-6">
                                <label>Usuário responsável:</label>
                                <p>{reserva.dataHoraEmbarque ? reserva.nomeResponsavelEmbarque : '-'}</p>
                            </div>
                        </div>
                        {/*<div className="row">*/}
                        {/*    <div className="col-sm-6">*/}
                        {/*        <label>Data/Hora desembaque:</label>*/}
                        {/*        <p>{reserva.dataHoraDesembarque ? reserva.dataHoraDesembarque : 'Passageiro não desembarcado'}</p>*/}
                        {/*    </div>*/}
                        {/*    <div className="col-sm-6">*/}
                        {/*        <label>Usuário responsável:</label>*/}
                        {/*        <p>{capitalizarTodasPrimeirasLetras(reserva.situacaoReserva)}</p>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {this.state.reserva.dataHoraEmbarque ?
                            <React.Fragment>
                                <div className='col-md-12 d-flex justify-content-center mt-4'>
                                    <i className="material-icons"
                                       style={{color: '#28a745', fontSize: '100px', verticalAlign: 'middle'}}>
                                        &#xe86c;
                                    </i>
                                </div>
                                <div className='col-md-12 d-flex justify-content-center'>
                                    <h4>Passageiro Embarcado</h4>
                                </div>
                            </React.Fragment> :
                            <div className='col-md-12 d-flex justify-content-center mt-4'>
                                <button onClick={() => this.embarcarPassageiro()}
                                        className="btn btn-laranja">EMBARCAR PASSAGEIRO
                                </button>
                            </div>}
                    </div>
                </div>
            </div>
            <div className="d-flex bd-highlight mb-3">
                <div className="p-2 bd-highlight">
                    <button onClick={() => this.setState({reserva: null})}
                            className="btn btn-laranja">Embarcar outro passageiro
                    </button>
                </div>
                <div className="ml-auto p-2 bd-highlight">
                    <button
                        onClick={() => this.props.history.push(`/painel-lista-passageiros?itinerario=${this.state.reserva.itinerarioId}&tipo=embarque`)}
                        className="btn btn-laranja">Acessar lista de passageiros
                    </button>
                </div>
            </div>
        </React.Fragment>
    }

    render() {
        const rota = this.props.itinerarioSelecionado.id ? this.props.itinerarioSelecionado.rotaDto : null;
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getMotoristaEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="col-md-12">
                    <div className='col-md-12'>
                        <Titulo texto="Embarque com QrCode" urlRetorno="/painel-embarque-passageiros"/>
                    </div>
                    {rota ? <h4 className='mb-2'>
                        <strong>Itinerário: </strong><span>{`${rota.prefixo ? rota.prefixo : 'Prefixo não informado'}: ${rota.cidadeOrigem.nome}-${rota.cidadeOrigem.uf} -> ${rota.cidadeDestino.nome}-${rota.cidadeDestino.uf} / ${rota.delimitacao ? rota.delimitacao : 'Delimitação não informada'}`}</span><br/>
                        <strong>Data/Hora
                            Partida: </strong><span>{this.props.itinerarioSelecionado.dataHoraPartida}</span>
                    </h4> : ''}
                    {this.state.reserva ? this.exibirDadosReserva() : this.exibirScanner()}

                </div>

            </Autorizacao>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        itinerarioSelecionado: state.itinerarioSelecionado,
    }
}

export default connect(mapStateToProps, {
    buscarReserva,
    embarcarPassageiro,
    buscarItinerario,
    selecionarItinerario
})(PainelEmbarqueComQrCode)
